// extracted by mini-css-extract-plugin
module.exports = {"headline":"channelCardStripGroup_headline__AV6u7","channelStripWrapper":"channelCardStripGroup_channelStripWrapper__LGhtg"};